<template>
	<a-config-provider :locale="antdLocale">
		<a-card :bordered="false">
			<a-row style="margin-bottom: 20px;">
				<a-col :span="10">
					<a-button type="primary" icon="plus" @click="handleCreate">
						{{l('AuditTeam_CreateTeam')}}
					</a-button>
					<a-button type="primary" icon="reload" @click="handleRefresh">{{l('Refresh')}}</a-button>
					<a-dropdown v-if="selectedRowKeys.length > 0">
						<a-menu slot="overlay">
							<a-menu-item key="1" @click="handleBatchDelete">
								<a-icon type="delete" />
								{{l('BatchDelete')}}
							</a-menu-item>
						</a-menu>
						<a-button style="margin-left: 8px">
							{{l('AuditTeam_BatchActions')}} <a-icon type="down" />
						</a-button>
					</a-dropdown>
				</a-col>

				<a-col :span="14" class="d-flex justify-content-end">
					<a-select :placeholder="l('AuditTeam_PleaseSelectStatus')" style="width: 200px;margin-right:10px;" @change="statusChange">
						<a-select-option :value="1">{{l('Enabled')}}</a-select-option>
						<a-select-option :value="0">{{l('Disabled')}}</a-select-option>
					</a-select>

					<a-input-search :placeholder="l('AuditTeam_PleaseInputTeamName')"
					    v-model.trim="queryParams.name" enterButton style="width: 200px;" @search="handleSearch">
					</a-input-search>
				</a-col>
			</a-row>
			<!-- 数据表格 -->
			<a-table :columns="columns" :data-source="dataSource" :loading="loading" :pagination="pagination"
				:rowSelection="rowSelection" rowKey="id" size="middle" @change="handleTableChange">
				<template slot="name" slot-scope="text, record">
				<a @click="handleView(record)">{{text}}</a>
			</template>
			<span slot="status" slot-scope="status">
					<a-badge :status="status === 1 ? 'success' : 'error'" :text="status === 1 ? l('Enabled') : l('Disabled')" />
				</span>

				<span slot="action" slot-scope="text, record">
					<a @click="handleManageMembers(record)">{{l('AuditTeam_ManageMembers')}}</a>
					<a-divider type="vertical" />
					<a-dropdown>
						<a class="ant-dropdown-link">
							{{l('AuditTeam_More')}} <a-icon type="down" />
						</a>
						<a-menu slot="overlay">
							<a-menu-item>
								<a @click="handleEdit(record)">{{l('AuditTeam_Edit')}}</a>
							</a-menu-item>
							<a-menu-item>
								<a-popconfirm :title="l('AuditTeam_DeleteConfirm')" @confirm="handleDelete(record)" :okText="l('AuditTeam_Confirm')"
									:cancelText="l('Cancel')">
									<a>{{l('Delete')}}</a>
								</a-popconfirm>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
				</span>
			</a-table>

			<!-- 新建/编辑弹窗 -->
			<create-edit-audit-team ref="createEditModal" @refresh="handleRefresh" />

			<!-- 查看详情弹窗 -->
			<view-audit-team ref="viewModal" @edit="handleEditFromView" @manageMembers="handleManageMembersFromView" />

			<!-- 管理成员弹窗 -->
			<manage-members ref="manageMembersModal" @refresh="handleRefresh" />
		</a-card>
	</a-config-provider>
</template>

<script>
	import AppComponentBase from '../../../shared/component-base/app-component-base.js'
	import {
		AuditTeamServiceProxy
	} from '../../../shared/service-proxies'
	import CreateEditAuditTeam from './create-edit-audit-team.vue'
	import ViewAuditTeam from './view-audit-team.vue'
	import ManageMembers from './manage-members.vue'
	import moment from 'moment'

	export default {
		mixins: [AppComponentBase],
		name: 'AuditTeam',
		components: {
			CreateEditAuditTeam,
			ViewAuditTeam,
			ManageMembers
		},
		data() {
			return {
				zh_CN: require('ant-design-vue/es/locale/zh_CN').default,
				loading: false,
				dataSource: [],
				serviceProxy: null,
				selectedRowKeys: [],
				queryParams: {
					name: null,
					status: null,
					leaderId: null,
					scenesId: null,
					startTime: null,
					endTime: null,
					sorting: null
				},
				pagination: {
					current: 1,
					pageSize: 20,
					total: 0,
					showSizeChanger: true,
					showQuickJumper: true,
					showTotal: (total, range) => this.l('AuditTeam_PaginationTotal', range[0], range[1], total)
				},
				columns: [{
						title: this.l('AuditTeam_TeamName'),
						dataIndex: 'name',
						key: 'name',
						width: 200,
						align: 'center',
						scopedSlots: { customRender: 'name' }
					},
					{
						title: this.l('Description'),
						dataIndex: 'description',
						key: 'description',
						width: 250,
						ellipsis: true,
						align: 'left'
					},
					{
						title: this.l('AuditTeam_Leader'),
						dataIndex: 'leaderName',
						key: 'leaderName',
						width: 120,
						align: 'center'
					},
					{
						title: this.l('AuditTeam_MemberCount'),
						dataIndex: 'memberCount',
						key: 'memberCount',
						width: 100,
						align: 'center'
					},
					{
						title: this.l('Status'),
						dataIndex: 'status',
						key: 'status',
						width: 80,
						scopedSlots: {
							customRender: 'status'
						},
						align: 'center'
					},
					{
						title: this.l('CreationTime'),
						dataIndex: 'creationTime',
						key: 'creationTime',
						width: 150,
						customRender: (text) => {
							return text ? moment(text).format('YYYY-MM-DD HH:mm') : ''
						}
					},
					{
						title: this.l('Actions'),
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
						width: 200,
						fixed: 'right'
					}
				]
			}
		},
		computed: {
			rowSelection() {
				return {
					selectedRowKeys: this.selectedRowKeys,
					onChange: this.onSelectChange
				}
			}
		},
		created() {
			this.serviceProxy = new AuditTeamServiceProxy(this.$apiUrl, this.$api)
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true

				const params = {
					name: this.queryParams.name,
					status: this.queryParams.status,
					leaderId: this.queryParams.leaderId,
					scenesId: this.queryParams.scenesId,
					startTime: this.queryParams.startTime,
					endTime: this.queryParams.endTime,
					sorting: this.queryParams.sorting,
					skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
					maxResultCount: this.pagination.pageSize
				}

				this.serviceProxy.getPaged(
						params.name,
						params.status,
						params.leaderId,
						params.scenesId,
						params.startTime,
						params.endTime,
						params.sorting,
						params.skipCount,
						params.maxResultCount
					)
					.then((result) => {
						this.dataSource = result.items || []
						this.pagination.total = result.totalCount || 0
						this.loading = false
					})
				.catch((error) => {
					console.error('获取数据失败:', error)
					this.$message.error(this.l('AuditTeam_GetDataFailed') + (error.message || error))
					this.dataSource = []
					this.pagination.total = 0
					this.loading = false
				})
			},

			statusChange(value) {
			    this.queryParams.status = value;
			    this.handleSearch();
			},

			handleSearch() {
				this.pagination.current = 1
				this.loadData()
			},

			handleRefresh() {
				this.selectedRowKeys = []
				this.loadData()
			},

			handleCreate() {
				this.$refs.createEditModal.open()
			},

			handleView(record) {
				this.$refs.viewModal.open(record.id)
			},

			handleEdit(record) {
				this.$refs.createEditModal.open(record.id)
			},

			handleDelete(record) {
				this.serviceProxy.delete(record.id)
					.then(() => {
						this.$message.success(this.l('AuditTeam_DeleteSuccess'))
						this.loadData()
					})
					.catch(error => {
						console.error('删除失败:', error)
						this.$message.error(this.l('AuditTeam_DeleteFailed') + (error.message || error))
					})
			},

			handleBatchDelete() {
				if (this.selectedRowKeys.length === 0) {
					this.$message.warning(this.l('AuditTeam_PleaseSelectToDelete'))
					return
				}

				this.$confirm({
					title: this.l('AuditTeam_ConfirmDeleteTitle'),
					content: this.l('AuditTeam_BatchDeleteConfirm', this.selectedRowKeys.length),
					okText: this.l('AuditTeam_Confirm'),
					okType: 'danger',
					cancelText: this.l('Cancel'),
					onOk: () => {
						this.serviceProxy.batchDelete(this.selectedRowKeys)
							.then(() => {
								this.$message.success(this.l('AuditTeam_BatchDeleteSuccess'))
								this.selectedRowKeys = []
								this.loadData()
							})
							.catch(error => {
								console.error('批量删除失败:', error)
								this.$message.error(this.l('AuditTeam_BatchDeleteFailed') + (error.message || error))
							})
					}
				})
			},

			handleManageMembers(record) {
				this.$refs.manageMembersModal.open(record.id, record.name)
			},

			// 从查看详情页面触发的编辑事件
			handleEditFromView(teamData) {
				this.$refs.createEditModal.open(teamData.id)
			},

			// 从查看详情页面触发的管理成员事件
			handleManageMembersFromView(teamData) {
				this.$refs.manageMembersModal.open(teamData.id, teamData.name)
			},

			onSelectChange(selectedRowKeys) {
				this.selectedRowKeys = selectedRowKeys
			},

			handleTableChange(pagination, filters, sorter) {
				const pager = {
					...this.pagination
				}
				pager.current = pagination.current
				pager.pageSize = pagination.pageSize
				this.pagination = pager

				// 处理排序
				if (sorter.field) {
					const sortField = sorter.field
					const sortOrder = sorter.order === 'ascend' ? ' asc' : ' desc'
					this.queryParams.sorting = `${sortField}${sortOrder}`
				} else {
					this.queryParams.sorting = null
				}

				this.loadData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.table-page-search-wrapper {
		.ant-form-inline {
			.ant-form-item {
				display: flex;
				margin-bottom: 24px;
				margin-right: 0;

				.ant-form-item-control-wrapper {
					flex: 1 1;
					display: inline-block;
					vertical-align: middle;
					min-width: 200px;
				}
			}

			.ant-form-item-control {
				line-height: 32px;
			}
		}

		.search-form-item {
			text-align: right;

			.ant-form-item-control {
				text-align: left;

				.ant-input,
				.ant-select {
					min-width: 200px;
				}
			}
		}

		.table-page-search-submitButtons {
			display: block;
			margin-bottom: 24px;
			white-space: nowrap;
			text-align: right;
		}
	}

	.table-operator {
		margin-bottom: 16px;

		.ant-btn {
			margin-right: 8px;
		}
	}
</style>